export default {
  tooltip: {
    '@media print': {
      display: 'none',
    },
  },
}
